import { Dropdown } from 'components-antd';
import { Button, Checkbox } from 'components';

import styles from './styles.module.scss';
import { useCallback, useState } from 'react';
import { Columns } from '../Columns';
import { useDispatch, useSelector } from 'react-redux';
import { getSymphonyColumns, getSymphonyStatsData } from 'store/selectors/symphony';
import {
  requestUpdateColumnsAction,
  requestUpdateSymphonyShowActiveAction,
} from 'store/actions/symphony';
import { requestUpdateSymphonyPreferencesEffect } from 'store/effects';

export const ColumnsDropdown = ({
  children,
  className = '',
  type = undefined,
  onVisibleChange = (visible) => {},
}) => {
  const dispatch = useDispatch();
  const { showActive } = useSelector(getSymphonyStatsData);
  const selectedColumns = useSelector(getSymphonyColumns);
  const [columns, setColumns] = useState(selectedColumns);
  const [isActive, setIsActive] = useState(showActive);

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const handleOpenDropdown = useCallback(() => setIsDropdownOpen(true), []);
  const handleCloseDropdown = useCallback(() => setIsDropdownOpen(false), []);

  return (
    <Dropdown
      onOpenChange={(state) => {
        setIsDropdownOpen(state);
        setColumns(selectedColumns);
        onVisibleChange(state);
      }}
      overlay={
        <div
          className={styles.dropdownContent}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <p className={styles.title}>Edit Columns</p>
          <Columns
            className={styles.columns}
            dropdown
            type={type}
            columns={columns}
            setColumns={setColumns}
          />
          <div className={styles.buttonContainer}>
            <Checkbox
              checked={!isActive}
              onChange={(e) => {
                setIsActive(!e.target.checked);
              }}
              label="Show inactive members"
              direction="right"
              labelTextClassName={styles.label}
            />
            <Button
              isPending={false}
              className={styles.button}
              onClick={() => {
                handleCloseDropdown();
                dispatch(requestUpdateColumnsAction(columns));
                dispatch(requestUpdateSymphonyShowActiveAction({ showActive: isActive }));
                dispatch(
                  requestUpdateSymphonyPreferencesEffect(
                    Object.values(columns)
                      .flat()
                      .map((val) => val),
                  ),
                );
              }}
              title={'Done'}
              disabled={false}
            />
          </div>
        </div>
      }
      overlayClassName={styles.actionsDropdown}
      trigger={['click']}
      placement="bottomRight"
      className={styles.actions}
      open={isDropdownOpen}
    >
      <div
        className={className}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleOpenDropdown();
        }}
      >
        {children}
      </div>
    </Dropdown>
  );
};
